import React, { Component } from 'react';
import { Paragraph } from '../../../legacy/hui/src/styled';
import styled from 'styled-components';
import Upload from 'rc-upload';
import PlusIcon from './icon/plus';
import Close from './icon/close';
import Alert from '../alert/alert';
import AlertIcon from './icon/alert';
import Loading from './icon/load.png';
import PropTypes from 'prop-types';

const ContainerV2 = styled.div`
  width: 100%;
  min-width: 320px;
  box-sizing: border-box;
  position: relative;
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
`;

ContainerV2.displayName = 'ContainerV2';

const DropContainer = styled.div`
  height: 60px;
  width: 60px;
  background-color: #efefef;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin: 0 12px 0 0;
  border-radius: 4px;
  &:hover {
    background-color: #c7c7c7;
  }
`;

const LoadingContainer = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  border-radius: 4px;
  background-color: #efefef;
`;

const ListImg = styled.img`
  width: 60px;
  height: 60px;
`;

const PrevListItem = styled.div`
  display: inline;
  padding: 0 12px 0 0;
  position: relative;
`;

const CloseIcon = styled.i`
  position: absolute;
  right: 16px;
  top: 4px;
  &:hover {
    cursor: pointer;
  }
`;

const AlertContainer = styled.span`
  position: relative;
  top: 3px;
  padding-right: 3px;
`;

const HeaderTextLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
  margin-bottom: 15px;
`;

const TitleTipsStyle = styled.label`
  display: block;
  margin-top: 0.625rem;
  color: #a1a1a3;
`;

const Uploads = styled(Upload)`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  border: 1px dashed ${props => (!props.isHover ? '#969696' : '#FF6600')};
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
  outline: none;
  margin-bottom: 15px;
  &:hover {
    border: 1px dashed #ff6600;
  }
`;
const loadingBlock = (
  <PrevListItem>
    <LoadingContainer>
      <img src={Loading} />
    </LoadingContainer>
  </PrevListItem>
);
const thumbs = (fn, files) => {
  return files.map(file => (
    <PrevListItem key={file.uid}>
      <CloseIcon onClick={e => fn(e, file)}>
        <Close />
      </CloseIcon>
      <ListImg src={file.preview} />
    </PrevListItem>
  ));
};

const changeUploadStatus = (uploading, uploaded, setUploading, setUploaded) => {
  setUploading(uploading);
  setUploaded(uploaded);
};

const errorHandler = (isError, msg, setError, errorInterval) => {
  setError({
    isError: isError,
    msg: msg
  });
  setTimeout(() => {
    setError({
      isError: false,
      msg: ''
    });
  }, errorInterval);
};

// notice: if upgrade the hui to V2.71.0+ and install js-package dependence,please use @hipagesgroup/file-upload instead of this

export class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      isHover: false,
      uploading: false,
      uploaded: true,
      error: {
        isError: false,
        msg: ''
      }
    };
  }

  render() {
    const {
      uploadUrl,
      tipText,
      headerText,
      acceptTypes = '.jpg,.jpeg,.pdf,.png',
      type = 'drag',
      successCallback,
      beforeUploadCallback,
      removeCallback,
      errorInterval = 3000
    } = this.props;
    const onStart = () => {
      changeUploadStatus(
        true,
        false,
        uploading => this.setState({ uploading }),
        uploaded => this.setState({ uploaded })
      );
    };
    const onSuccess = (response, file, xhr) => {
      changeUploadStatus(
        false,
        true,
        uploading => this.setState({ uploading }),
        uploaded => this.setState({ uploaded })
      );
      this.setState({ hover: false });
      const newFile = successCallback(response, file, xhr);
      this.setState({
        files: [
          ...this.state.files,
          {
            uid: newFile.uid,
            name: newFile.name,
            preview: newFile.preview
          }
        ]
      });
    };
    const onError = () => {
      changeUploadStatus(
        false,
        true,
        uploading => this.setState({ uploading }),
        uploaded => this.setState({ uploaded })
      );
      this.setState({ hover: false });
      errorHandler(
        true,
        'There was a problem uploading your file. Please try again.',
        error => this.setState({ error }),
        errorInterval
      );
    };
    const beforeUpload = file => {
      const { result, msg } = beforeUploadCallback(this.state.files, file);
      this.setState({ hover: false });
      if (result) {
        errorHandler(true, `${msg}`, error => this.setState({ error }), errorInterval);
        return false;
      }
      return true;
    };
    const UploadProps = {
      component: 'div',
      action: uploadUrl,
      type: type,
      accept: acceptTypes,
      disabled: !this.state.uploaded,
      className: 'rcupload',
      beforeUpload: beforeUpload,
      onStart: onStart,
      onSuccess: onSuccess,
      onError: onError
    };
    const removeFile = (e, file) => {
      e.stopPropagation();
      const { result, msg } = removeCallback(file);
      if (result) {
        const tmpFiles = this.state.files.filter(item => item.uid !== file.uid);
        this.setState({
          files: tmpFiles
        });
      } else {
        errorHandler(true, `${msg}`, error => this.setState({ error }), errorInterval);
      }
    };
    const onFileDrop = () => {
      this.setState({ isHover: true });
    };
    // notice: if upgrade the hui to V2.71.0+ and install js-package dependence,please notice the style of headerText and tipText
    return (
      <ContainerV2>
        <HeaderTextLabel>
          {headerText || 'Attach files (optional)'}
          <TitleTipsStyle>
            {tipText || 'Maximum of 5 photos or pdfs can be uploaded'}
          </TitleTipsStyle>
        </HeaderTextLabel>
        <div onDrop={onFileDrop} onDragOver={onFileDrop} onDragLeave={onFileDrop}>
          <Uploads {...UploadProps} isHover={this.state.isHover}>
            <DropContainer>
              <PlusIcon />
            </DropContainer>
            {this.state.uploading && loadingBlock}
            {thumbs(removeFile, this.state.files)}
          </Uploads>
        </div>
        {this.state.error.isError && (
          <Alert color="danger">
            <Paragraph mb={0}>
              <AlertContainer>
                <AlertIcon />
              </AlertContainer>
              {this.state.error.msg}
            </Paragraph>
          </Alert>
        )}
      </ContainerV2>
    );
  }
}

FileUpload.propTypes = {
  uploadUrl: PropTypes.string,
  acceptTypes: PropTypes.string,
  headerText: PropTypes.string,
  tipText: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  debug: PropTypes.bool,
  successCallback: PropTypes.func,
  beforeUploadCallback: PropTypes.func,
  removeCallback: PropTypes.func,
  errorInterval: PropTypes.number
};
